/**
 * Yellow banner shown above ContextView when an admin is viewing the teacher
 * portal (view-as-teacher mode). Real teachers never see it.
 *
 * Per plan §5.1 — discovery happens via "View as teacher → {Subject}" buttons
 * on Batch / Teacher / Center detail pages. The URL itself is the impersonation
 * gesture; the banner makes it impossible to forget who you're viewing as.
 */

import { Link } from 'react-router-dom';

export default function AdminImpersonationBanner({ teacher, batch, subject, centerName }) {
  const teacherName = teacher
    ? `${teacher.first_name || ''} ${teacher.last_name || ''}`.trim() || teacher.email
    : '—';
  const subjectLabel = subject
    ? subject.charAt(0).toUpperCase() + subject.slice(1)
    : '—';

  return (
    <div className="bg-amber-100 border-b border-amber-300 text-amber-900 px-6 py-2 flex items-center justify-between text-sm font-teacher">
      <div className="flex items-center gap-2">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
        <span>
          <span className="opacity-75">Viewing as</span>{' '}
          <strong>{teacherName}</strong>
          {' · '}
          <span>{batch?.name || '—'}</span>
          {' · '}
          <strong>{subjectLabel}</strong>
          {centerName && <> {' · '} <span className="opacity-75">{centerName}</span></>}
        </span>
      </div>
      <Link to="/" className="font-medium underline hover:no-underline">
        Exit to admin
      </Link>
    </div>
  );
}
